import React from 'react';
import { useFilterContext } from '../../context/aptmetrix/FilterContext';
import { useTooltip } from './useTooltip';
import { handleIntegerInput } from './inputHelpers';
import FilterButton from './FilterButton';
import TooltipShell, { FilterActions } from './TooltipShell';

const MoveInDateFilter = ({ isOpen, onToggle, onClose, selectedRegion, data, onFilterChange }) => {
    const {
        filterUIState,
        setFilterUIState,
    } = useFilterContext();

    const { minYears, maxYears, isMoveInDateFilterActive } = filterUIState;

    const { tooltipRef, buttonRef } = useTooltip(isOpen, onClose);

    const updateUI = (updates) => setFilterUIState(prev => ({ ...prev, ...updates }));
    const setMinYears = (v) => updateUI({ minYears: v });
    const setMaxYears = (v) => updateUI({ maxYears: v });

    const handleToggle = () => {
        if (!selectedRegion) {
            alert('지역을 먼저 선택하세요');
            return;
        }
        onToggle();
    };

    const apply = () => {
        const minVal = minYears ? parseInt(minYears, 10) : null;
        const maxVal = maxYears ? parseInt(maxYears, 10) : null;
        updateUI({ isMoveInDateFilterActive: minVal !== null || maxVal !== null });
        onFilterChange({ minYears: minVal, maxYears: maxVal });
        onClose();
    };

    const reset = () => {
        updateUI({ minYears: '', maxYears: '', isMoveInDateFilterActive: false });
        onFilterChange({ minYears: null, maxYears: null });
        onClose();
    };

    const isDisabled = !data || data.length === 0;

    return (
        <div className="relative">
            <FilterButton
                ref={buttonRef}
                label="입주일"
                activeLabel="입주일적용"
                isActive={isMoveInDateFilterActive}
                isDisabled={isDisabled}
                onClick={handleToggle}
            />
            {isOpen && (
                <TooltipShell ref={tooltipRef} title="연식설정" onClose={onClose}>
                    <div className="flex items-center justify-between mb-3">
                        <input
                            type="text"
                            value={minYears}
                            onChange={(e) => handleIntegerInput(e, setMinYears)}
                            placeholder="최소 연수"
                            className="w-24 p-1 border border-gray-300 rounded-lg text-center text-sm"
                        />
                        <span className="mx-1">~</span>
                        <input
                            type="text"
                            value={maxYears}
                            onChange={(e) => handleIntegerInput(e, setMaxYears)}
                            placeholder="최대 연수"
                            className="w-24 p-1 border border-gray-300 rounded-lg text-center text-sm"
                        />
                    </div>
                    <div className="text-xs text-gray-500 mb-2 text-right">(단위: 년)</div>
                    <FilterActions onReset={reset} onApply={apply} />
                </TooltipShell>
            )}
        </div>
    );
};

export default MoveInDateFilter;
